import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "create-upgrade-plan" }
const _hoisted_2 = { class: "info-hero" }
const _hoisted_3 = { class: "hero-main" }
const _hoisted_4 = { class: "hero-avatar" }
const _hoisted_5 = { class: "hero-text" }
const _hoisted_6 = { class: "hero-title" }
const _hoisted_7 = {
  key: 0,
  class: "hero-subtitle"
}
const _hoisted_8 = {
  key: 0,
  class: "step-card"
}
const _hoisted_9 = { class: "step-card-header" }
const _hoisted_10 = { class: "step-badge done" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "step-card-title" }
const _hoisted_13 = {
  key: 0,
  class: "title-extra"
}
const _hoisted_14 = {
  key: 0,
  class: "step-card-body"
}
const _hoisted_15 = { class: "ship-info-grid" }
const _hoisted_16 = { class: "info-card" }
const _hoisted_17 = { class: "info-icon" }
const _hoisted_18 = { class: "info-body" }
const _hoisted_19 = { class: "info-value" }
const _hoisted_20 = { class: "info-card" }
const _hoisted_21 = { class: "info-icon info-icon-cyan" }
const _hoisted_22 = { class: "info-body" }
const _hoisted_23 = { class: "info-value" }
const _hoisted_24 = {
  key: 1,
  class: "step-card"
}
const _hoisted_25 = { class: "step-card-header" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "step-card-title" }
const _hoisted_28 = {
  key: 0,
  class: "title-extra"
}
const _hoisted_29 = { class: "step-card-body" }
const _hoisted_30 = { class: "el-upload__text" }
const _hoisted_31 = { class: "el-upload__tip" }
const _hoisted_32 = { class: "step-card-header" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "step-card-title" }
const _hoisted_35 = { class: "step-card-body" }
const _hoisted_36 = {
  key: 0,
  class: "plan-issues"
}
const _hoisted_37 = { class: "plan-issues-body" }
const _hoisted_38 = {
  key: 1,
  class: "svc004-section"
}
const _hoisted_39 = { class: "plan-table-head" }
const _hoisted_40 = { class: "col" }
const _hoisted_41 = { class: "col" }
const _hoisted_42 = { class: "col" }
const _hoisted_43 = { class: "col" }
const _hoisted_44 = { class: "col col-help" }
const _hoisted_45 = { class: "col col-help" }
const _hoisted_46 = { class: "col col-help" }
const _hoisted_47 = { class: "col" }
const _hoisted_48 = { class: "col col-action" }
const _hoisted_49 = { class: "col-title" }
const _hoisted_50 = { class: "row-index" }
const _hoisted_51 = { class: "col" }
const _hoisted_52 = { class: "col" }
const _hoisted_53 = { class: "col" }
const _hoisted_54 = { class: "col" }
const _hoisted_55 = { class: "col" }
const _hoisted_56 = {
  key: 0,
  class: "sub-id-container"
}
const _hoisted_57 = { class: "sub-id-tag-wrap" }
const _hoisted_58 = {
  key: 2,
  class: "sub-id-tip"
}
const _hoisted_59 = { class: "col" }
const _hoisted_60 = {
  key: 0,
  class: "sub-id-container"
}
const _hoisted_61 = { class: "sub-id-tag-wrap" }
const _hoisted_62 = {
  key: 0,
  class: "sub-id-tip"
}
const _hoisted_63 = { class: "col" }
const _hoisted_64 = { class: "sub-id-container" }
const _hoisted_65 = { class: "sub-id-tag-wrap" }
const _hoisted_66 = {
  key: 0,
  class: "sub-id-tip"
}
const _hoisted_67 = { class: "col" }
const _hoisted_68 = { class: "col col-action" }
const _hoisted_69 = { class: "endpoint-info" }
const _hoisted_70 = { class: "endpoint-firmware" }
const _hoisted_71 = {
  key: 0,
  class: "firmware-fail"
}
const _hoisted_72 = {
  key: 1,
  class: "firmware-fail"
}
const _hoisted_73 = {
  key: 2,
  class: "firmware-fail"
}
const _hoisted_74 = { class: "firmware-value" }
const _hoisted_75 = {
  key: 0,
  class: "firmware-time"
}
const _hoisted_76 = {
  key: 4,
  class: "firmware-fail"
}
const _hoisted_77 = { class: "svc001-file-section" }
const _hoisted_78 = { class: "svc001-file-row" }
const _hoisted_79 = { class: "svc001-file-row" }
const _hoisted_80 = { class: "svc001-file-row" }
const _hoisted_81 = { class: "step-card-header" }
const _hoisted_82 = { key: 1 }
const _hoisted_83 = { class: "step-card-title" }
const _hoisted_84 = {
  key: 0,
  class: "title-extra"
}
const _hoisted_85 = { class: "step-card-body" }
const _hoisted_86 = {
  key: 0,
  class: "time-locked-tip"
}
const _hoisted_87 = {
  key: 4,
  class: "sticky-action-bar"
}
const _hoisted_88 = { class: "bar-progress" }
const _hoisted_89 = { class: "progress-indicator" }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = { key: 1 }
const _hoisted_93 = { key: 1 }

import { loadTranslations, translateName } from "@/composables/useTranslation";
import { getEndpointListApi } from "@/api/endpoint/endpointApi";
import { getDeviceListApi } from "@/api/deviceApi";
import {
  createDeviceUpgradePlanApi,
  createEndpointUpgradePlanApi,
  createSvc004UpgradeTaskApi,
  queryEndpointFirmwareApi,
  type EndpointFirmwareInfo,
} from "@/api/operation/upgradeApi";
import { getShipInfoApi, validateShipAuthorizationApi } from "@/api/productApi";
import router from "@/router";
import { Endpoint } from "@/types/endpoint";
import { DeviceItem } from "@/types/device";
import {
  LvInputState,
  Svc004DevicePlan,
  SUB_TYPE_MAP,
  UpgradePlan,
} from "@/types/operation";
import { Ship as ShipEntity } from "@/types/product";
import { httpAuthorized } from "@/util/http";
import {
  ArrowLeft,
  CircleCheck,
  Delete,
  Document,
  InfoFilled,
  Lock,
  Plus,
  Promotion,
  QuestionFilled,
  Ship,
  WarningFilled,
} from "@element-plus/icons-vue";
import {
  ElMessage,
  UploadFile,
  UploadFiles,
  UploadUserFile,
} from "element-plus";
import _, { throttle } from "lodash";
import { computed, nextTick, onMounted, reactive, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateUpgradePlanView',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const config = {
  minimumTimeInterval: 10,
};

// 船舶选择
const shipId = computed(() => route.query.shipId as string);
const ship = ref<ShipEntity>();
const isShipContentVisible = ref<boolean>(false);
const getShipInfo = async () => {
  const response = await getShipInfoApi(shipId.value);
  if (response) {
    ship.value = response.ship;
  } else {
    router.replace({ name: "overall" });
  }
  // 管理员对船舶的写入权限认证
  const writeAuthority = await validateShipAuthorizationApi(shipId.value, 16);
  if (!writeAuthority) {
    ElMessage.error(
      "管理员对" + ship.value?.name + "的写入权限已过期，请重新申请"
    );
    router.replace({ name: "overall" });
  }
};

// 文件选择
const isFileContentVisible = ref<boolean>(true);
const fileList = ref<UploadUserFile[]>([]);
const selectedFile = ref<UploadUserFile>();
watch(fileList, (list: UploadUserFile[]) => {
  if (list.length > 0) {
    isFileContentVisible.value = false;
  }
});
const handleFileChange = async (file: UploadFile, files: UploadFiles) => {
  if (!file) return;
  if (!file.size) return;

  // Svc001 三文件改造：不再前端计算 MD5（终端升级三文件无 MD5 码；
  // 设备升级的 fileMd5 改用后端上传返回的磁盘 MD5）
  if (file.raw) {
    fileIdRefTable.value.push({
      id: "",
      uid: Number(file.uid),
      name: file.name,
      path: "",
      fileMd5: "",
    });
  }
};
const handleFileRemove = (file: UploadFile, files: UploadFiles) => {
  planList.value.forEach((item) => {
    if (item.fileId === file.uid) {
      item.fileId = null;
    }
  });
  svc004PlanList.value.forEach((item) => {
    if (item.fileUid === file.uid) {
      item.fileUid = null;
    }
  });
  if (endpointFileSelection.value == file.uid) {
    endpointFileSelection.value = undefined;
  }
  // Svc001 三文件：同步清理已删文件的角色引用，避免残留 uid 导致
  // isValidPlanSet 误通过 / 提交空 md5FileId 等脏数据
  if (svc001FileSelection.firmware === file.uid) {
    svc001FileSelection.firmware = undefined;
  }
  if (svc001FileSelection.md5 === file.uid) {
    svc001FileSelection.md5 = undefined;
  }
  if (svc001FileSelection.sign === file.uid) {
    svc001FileSelection.sign = undefined;
  }
  // 移除 fileIdRefTable 中已删文件的条目，避免残留 id="" 条目
  // 触发创建时 some((e) => !e.id) 误判"上传终止"
  fileIdRefTable.value = fileIdRefTable.value.filter(
    (entry) => entry.uid !== file.uid
  );
};

// 时间选择
const isTimeContentVisible = ref<boolean>(true);
const upgradeDate = ref<string>();
const getTargetTime = (second: number) => {
  const now = new Date();
  now.setSeconds(now.getSeconds() + second);
  return now;
};
const optionsDisable = (time: Date) => {
  return time.getTime() < Date.now() + 9 * 60 * 1000;
};

/**
 * 是否满足创建条件
 */
const canCreate = computed(() => {
  return (
    !!ship.value &&
    fileList.value.length > 0 &&
    !!upgradeSelection.value &&
    isValidPlanSet() &&
    !!upgradeDate.value
  );
});
const shorcuts = [
  {
    text: "20秒后",
    value: () => {
      const date = new Date();
      date.setSeconds(date.getSeconds() + 20);
      return date;
    },
  },
  {
    text: "1分钟后",
    value: () => {
      const date = new Date();
      date.setSeconds(date.getSeconds() + 60);
      return date;
    },
  },
  {
    text: "20分钟后",
    value: () => {
      const date = new Date();
      date.setMinutes(date.getMinutes() + 20);
      return date;
    },
  },
  {
    text: "1小时后",
    value: () => {
      const date = new Date();
      date.setMinutes(date.getMinutes() + 60);
      return date;
    },
  },
  {
    text: "2小时后",
    value: () => {
      const date = new Date();
      date.setMinutes(date.getMinutes() + 120);
      return date;
    },
  },
];

const showErrorMessage = throttle((message: string) => {
  ElMessage.error(message);
}, 1000); // 限制 1 秒内最多执行一次

watch(upgradeDate, (newDate) => {
  if (newDate) {
    upgradeDate.value = isDateBeforeMinimum(
      newDate,
      config.minimumTimeInterval
    );
  }
});
const isDateBeforeMinimum = (date: string, second: number) => {
  const planTime = new Date(date);
  const minimumTime = getTargetTime(second);
  if (planTime.getTime() < minimumTime.getTime()) {
    showErrorMessage(t("CUPV.timeError")); // 受 throttle 限制
    console.log(minimumTime.toDateString());
    return minimumTime;
  }
  return date;
};

// 终端升级计划
const endpointSelection = ref<string>();
const endpointList = ref<Endpoint[]>([]);
const endpointFileSelection = ref<number>();

// 终端当前固件名（Svc001 [1,4]/[1,5] 查询）
const endpointFirmware = ref<EndpointFirmwareInfo | null>(null);
const firmwareLoading = ref(false);
const loadEndpointFirmware = async (force: boolean) => {
  if (!endpointSelection.value) return;
  firmwareLoading.value = true;
  try {
    const res = await queryEndpointFirmwareApi(
      [endpointSelection.value],
      force
    );
    if (res && res.length > 0) {
      endpointFirmware.value = res[0];
    }
  } finally {
    firmwareLoading.value = false;
  }
};

const getEndpointList = async () => {
  const response = await getEndpointListApi(shipId.value);
  if (response) {
    endpointList.value = response;
    // 自动选择该船舶的终端（只有一个），无需手动选择
    if (response.length > 0) {
      endpointSelection.value = response[0].id;
      // 加载库内固件名快照（不发 MQTT）
      loadEndpointFirmware(false);
    }
  } else {
    router.back();
  }
};

const getDeviceList = async () => {
  const response = await getDeviceListApi(shipId.value);
  if (response) {
    deviceList.value = response;
  }
};

// 设备升级计划
const isCodeContentVisible = ref<boolean>(true);
const upgradeSelection = ref<number>(2);
const planList = ref<UpgradePlan[]>([
  {
    typeId: null,
    positions: [],
    fileId: null,
  },
]);

// Svc004 新协议设备升级计划（每行一个子设备）
const svc004PlanList = ref<Svc004DevicePlan[]>([
  {
    devType: "",
    devName: "",
    subType: null,
    subName: "",
    subInfo: "",
    subInfoError: false,
    subLv: null,
    lv3: { val: "", list: [], input: "", error: false },
    lv2: { val: "", list: [], input: "", error: false },
    lv1: { val: "", list: [], input: "", error: false },
    fileUid: null,
  },
]);

// 设备列表（从后端查询）
const deviceList = ref<DeviceItem[]>([]);

// 获取设备类型列表（去重+正序排序）
const deviceTypeList = computed(() => {
  const types = [...new Set(deviceList.value.map((d) => d.type))];
  return types.sort((a, b) => a.localeCompare(b));
});

// 根据设备类型获取设备名称列表（去重+正序排序）
const getDeviceNamesByType = (devType: string) => {
  if (!devType) return [];
  const names = [
    ...new Set(
      deviceList.value.filter((d) => d.type === devType).map((d) => d.name)
    ),
  ];
  names.sort((a, b) => a.localeCompare(b));
  return names.map((name) => ({ name }));
};

// 设备类型变更时，清空设备名称和子设备信息
const onDevTypeChange = (plan: Svc004DevicePlan) => {
  plan.devName = "";
  plan.subType = null;
  plan.subName = "";
  plan.subInfo = "";
  plan.subInfoError = false;
  plan.lv3.error = false;
  plan.lv2.error = false;
  plan.lv1.error = false;
};

// BMS类型：下拉选择子设备名称-类型
const onSubInfoChange = (plan: Svc004DevicePlan) => {
  if (!plan.subInfo) {
    plan.subName = "";
    plan.subType = null;
    return;
  }
  const parts = plan.subInfo.split("-");
  plan.subName = parts[0] || "";
  plan.subType = parts.length > 1 ? Number(parts[1]) : null;
};

// 非BMS类型：输入框失焦时解析子设备名称-类型
const onSubInfoBlur = (plan: Svc004DevicePlan) => {
  if (!plan.subInfo) {
    plan.subName = "";
    plan.subType = null;
    plan.subInfoError = false;
    return;
  }
  const parts = plan.subInfo.split("-");
  if (parts.length !== 2 || !parts[0] || !parts[1]) {
    plan.subInfoError = true;
    plan.subName = "";
    plan.subType = null;
    ElMessage.warning(
      "子设备名称-类型格式不正确，请使用'名称-类型'格式，如 EMU-6"
    );
    return;
  }
  const typeNum = Number(parts[1]);
  if (isNaN(typeNum) || typeNum < 1 || typeNum > 255) {
    plan.subInfoError = true;
    plan.subName = "";
    plan.subType = null;
    ElMessage.warning("子设备类型必须为1~255的数字");
    return;
  }
  plan.subInfoError = false;
  plan.subName = parts[0];
  plan.subType = typeNum;
};

// 非BMS类型：输入时清除错误状态
const onSubInfoInput = (plan: Svc004DevicePlan) => {
  plan.subInfoError = false;
};

const addPlan = () => {
  planList.value.push({
    typeId: null,
    positions: [],
    fileId: null,
  });
};

const addSvc004Plan = () => {
  svc004PlanList.value.push({
    devType: "",
    devName: "",
    subType: null,
    subName: "",
    subInfo: "",
    subInfoError: false,
    subLv: null,
    lv3: { val: "", list: [], input: "", error: false },
    lv2: { val: "", list: [], input: "", error: false },
    lv1: { val: "", list: [], input: "", error: false },
    fileUid: null,
  });
};

const deleteSvc004Plan = (index: number) => {
  svc004PlanList.value.splice(index, 1);
};

/**
 * 解析三段式子设备地址（三级-二级-一级），合法返回规范化字符串，非法返回 null。
 *
 * 格式规则：
 * - 三段以 "-" 分隔，如 1-2-12 = 三级设备1 下的二级设备2 下的一级设备12
 * - 每段为 1~255 整数或星号 *（全角 ＊ 统一转半角）
 * - * 表示无该级下级，即前段定位的设备本身就是升级目标：
 *   1-1-* = 三级1下的二级设备1本身；1-*-* = 三级设备1本身
 * - 兼容：输入含 0 自动转 *（1-0-0 → 1-*-*、1-4-0 → 1-4-*；0 后还有非 0 段则非法，如 1-0-5）
 * - 约束：第一段必须为数字；第二段为 * 时第三段必须为 *；
 *   不支持"全部"通配，需升级多个设备时逐个添加
 *
 * @param input 用户输入
 * @returns 规范化地址（如 "1-2-12"），非法返回 null
 */
const parseSubAddr = (input: string): string | null => {
  // 归一化：去首尾/内部空格、全角横杠/全角星号转半角（Excel/中文输入法常见）
  const val = input
    .trim()
    .replace(/\s+/g, "")
    .replace(/[－—–]/g, "-")
    .replace(/＊/g, "*");
  if (!val) return null;
  let parts = val.split("-");
  if (parts.length !== 3) return null;
  // 每段必须为整数或星号 *（0 暂容忍，下方自动转 *）
  if (parts.some((p) => p !== "*" && !/^\d+$/.test(p))) return null;
  // 旧写法兼容：0 表示无下级，从第一个 0 段起自动转为 *
  // （1-0-0 → 1-*-*、1-4-0 → 1-4-*；0 后还有非 0 段则非法，如 1-0-5）
  const firstZero = parts.findIndex((p) => p === "0");
  if (firstZero !== -1) {
    if (parts.slice(firstZero + 1).some((p) => p !== "0")) return null;
    parts = parts.map((p, i) => (i >= firstZero ? "*" : p));
  }
  // 数字段范围 1~255
  if (parts.some((p) => p !== "*" && (Number(p) < 1 || Number(p) > 255))) {
    return null;
  }
  // 第一段必须为数字（无"全部三级"通配概念）
  if (parts[0] === "*") return null;
  // 第二段为 *（无二级下级）时，第三段必须为 *
  if (parts[1] === "*" && parts[2] !== "*") return null;
  return parts.join("-");
};

/** 非法字符提示（节流，避免连续拦截时弹窗刷屏） */
const showSubIdInputError = throttle(() => {
  ElMessage.warning("仅允许输入数字");
}, 1000);

/**
 * Excel 粘贴批量添加：支持一行多列（TAB 分隔）、多行一列（换行分隔）及混合格式，
 * 自动忽略空单元格与无法识别的文字，仅添加合法地址（自动去重）
 */

/** 校验 1~255 整数，合法返回原串，非法返回 null */
const parseLvNum = (val: string): string | null => {
  const t = val.trim();
  return /^\d+$/.test(t) && Number(t) >= 1 && Number(t) <= 255 ? t : null;
};

/** 子设备地址是否填写就绪（按层级校验三个序号框） */
const isSubAddrReady = (plan: Svc004DevicePlan): boolean => {
  if (plan.subLv === 3) return plan.lv3.list.length > 0;
  if (plan.subLv === 2)
    return parseLvNum(plan.lv3.val) !== null && plan.lv2.list.length > 0;
  if (plan.subLv === 1)
    return (
      parseLvNum(plan.lv3.val) !== null &&
      parseLvNum(plan.lv2.val) !== null &&
      plan.lv1.list.length > 0
    );
  return false;
};

/** 固定前缀段（层级3=[]；层级2=[三级]；层级1=[三级,二级]；单值框未填好返回 null） */
const fixedSegs = (plan: Svc004DevicePlan): string[] | null => {
  if (plan.subLv === 3) return [];
  const lv3 = parseLvNum(plan.lv3.val);
  if (lv3 === null) return null;
  if (plan.subLv === 2) return [lv3];
  const lv2 = parseLvNum(plan.lv2.val);
  if (lv2 === null) return null;
  return [lv3, lv2];
};

/** 按层级拼装完整三段式地址（协议格式，后端零改动） */
const buildFullSubIds = (plan: Svc004DevicePlan): string[] => {
  const fixed = fixedSegs(plan);
  if (fixed === null) return [];
  if (plan.subLv === 3) return plan.lv3.list.map((n) => `${n}-*-*`);
  if (plan.subLv === 2) return plan.lv2.list.map((n) => `${fixed[0]}-${n}-*`);
  return plan.lv1.list.map((n) => `${fixed[0]}-${fixed[1]}-${n}`);
};

/** 地址预览文案：前 3 个完整地址 + 总数 */
const previewAddrs = (plan: Svc004DevicePlan): string => {
  const list = buildFullSubIds(plan);
  const head = list.slice(0, 3).join("、");
  return list.length > 3 ? `${head} 等 ${list.length} 个` : head;
};

/** 层级切换：清空三个序号框（不同层级下编号含义不同，避免残留脏数据） */
const onSubLvChange = (plan: Svc004DevicePlan) => {
  plan.lv3 = { val: "", list: [], input: "", error: false };
  plan.lv2 = { val: "", list: [], input: "", error: false };
  plan.lv1 = { val: "", list: [], input: "", error: false };
};

/** 多值框输入过滤：仅数字，非法字符拦截并红框 + 节流提示 */
const onLvInput = (lv: LvInputState) => {
  const raw = lv.input;
  const filtered = raw.replace(/[^0-9]/g, "");
  if (filtered !== raw) {
    lv.input = filtered;
    lv.error = true;
    showSubIdInputError();
  } else {
    lv.error = false;
  }
};

/** 多值框回车添加编号（1~255，去重） */
const handleLvEnter = (lv: LvInputState) => {
  const val = lv.input.trim();
  if (!val) return;
  if (parseLvNum(val) === null) {
    lv.error = true;
    ElMessage.warning("请输入 1~255 的设备编号");
    return;
  }
  if (lv.list.includes(val)) {
    lv.error = true;
    ElMessage.warning(`编号 ${val} 已存在`);
    return;
  }
  lv.error = false;
  lv.list.push(val);
  lv.input = "";
};

/** 单值框输入：仅数字 + 清除红框 */
const onLvValInput = (lv: LvInputState) => {
  lv.val = lv.val.replace(/[^0-9]/g, "");
  lv.error = false;
};

/** 单值框失焦校验（空值不标红，由缺失项提示兜底） */
const onLvValBlur = (lv: LvInputState) => {
  if (!lv.val.trim()) {
    lv.error = false;
    return;
  }
  lv.error = parseLvNum(lv.val) === null;
};

/**
 * 多值框粘贴双模式：纯编号直接加；完整三段式地址按固定前缀校验后取对应段
 * @param segIdx 该框对应的段位（0=三级 1=二级 2=一级）
 */
const handleLvPaste = (
  plan: Svc004DevicePlan,
  segIdx: number,
  lv: LvInputState,
  event: ClipboardEvent
) => {
  const text = event.clipboardData?.getData("text") || "";
  if (!text.trim()) return;
  event.preventDefault();

  const fixed = fixedSegs(plan);
  if (fixed === null || fixed.length !== segIdx) {
    lv.error = true;
    ElMessage.warning("请先正确填写上级编号");
    return;
  }

  const tokens = text.split(/[\r\n\t,，;；/|\s]+/);
  let added = 0;
  let fromAddr = 0;
  let ignored = 0;
  tokens.forEach((token) => {
    const t = token.trim();
    if (!t) return; // 空单元格跳过
    if (/^\d+$/.test(t)) {
      if (parseLvNum(t) !== null) {
        if (!lv.list.includes(t)) {
          lv.list.push(t);
          added++;
        }
      } else {
        ignored++; // 编号越界
      }
      return;
    }
    const addr = parseSubAddr(t);
    if (!addr) {
      ignored++; // 格式非法
      return;
    }
    const seg = addr.split("-");
    let num: string | null = null;
    if (segIdx === 0 && seg[1] === "*" && seg[2] === "*") {
      num = seg[0];
    } else if (segIdx === 1 && seg[2] === "*" && seg[0] === fixed[0]) {
      num = seg[1];
    } else if (segIdx === 2 && seg[0] === fixed[0] && seg[1] === fixed[1]) {
      num = seg[2];
    }
    if (num !== null) {
      if (!lv.list.includes(num)) {
        lv.list.push(num);
        added++;
        fromAddr++;
      }
    } else {
      ignored++; // 层级或上级编号不符
    }
  });

  if (added > 0) {
    lv.error = false;
    lv.input = "";
    const addrTip = fromAddr > 0 ? `（${fromAddr} 个从地址提取）` : "";
    if (ignored > 0) {
      ElMessage.warning(
        `已添加 ${added} 个编号${addrTip}，忽略 ${ignored} 项（越界/格式/层级/路径不符）`
      );
    } else if (fromAddr > 0) {
      ElMessage.info(`已添加 ${added} 个编号${addrTip}`);
    }
  } else if (ignored > 0) {
    lv.error = true;
    ElMessage.warning("粘贴内容中未识别到符合当前层级与上级编号的设备编号");
  }
};

/**
 * 添加子设备地址标签
 * @param plan 当前设备升级计划行
 */

// 设备位置内容确认
const handlePositionInput = (value: string, plan: UpgradePlan) => {
  const positions = plan.positions;
  const regex = /^(\d+)-(\d+)-(\d+)$/;
  const match = value.match(regex);

  // 不符合 "数字-数字-数字" 格式
  if (!match) {
    console.log("不符合格式:", value);
    plan.positions = positions.filter((item) => item != value);
    return;
  }

  // 提取 3 个数字并转换为数值
  const [_, n1, n2, n3] = match;
  const num1 = parseInt(n1, 10);
  const num2 = parseInt(n2, 10);
  const num3 = parseInt(n3, 10);

  // 检查是否在 0-255 之间，并确保不重复
  if (
    num1 < 0 ||
    num1 >= 256 ||
    num2 < 0 ||
    num2 >= 256 ||
    num3 < 0 ||
    num3 >= 256
  ) {
    console.log("不符合范围:", value);
    plan.positions = positions.filter((item) => item != value);
    return;
  }
  console.log("去重:", value);
  plan.positions = Array.from(new Set(positions));
};

// 设备位置粘贴解析
const handlePositionPaste = (plan: UpgradePlan) => {
  navigator.clipboard.readText().then((text) => {
    if (!text) return;

    // 允许的分隔符：逗号(,)、分号(;)、斜杠(/)、空格、换行(\n, \r)
    const newPositions = text
      .split(/[\n\r\t,，;；/ ]+/) // 按分隔符拆分
      .map((position) => position.trim()) // 去掉首尾空格
      .filter((position) => {
        const regex = /^(\d+)-(\d+)-(\d+)$/;
        const match = position.match(regex);
        if (!match) {
          console.log("不符合格式:", position);
          return false;
        }
        const [_, n1, n2, n3] = match;
        const num1 = parseInt(n1, 10);
        const num2 = parseInt(n2, 10);
        const num3 = parseInt(n3, 10);
        console.log(num1, num2, num3);

        // 检查是否在 0-255 之间，并确保不重复
        if (
          num1 < 0 ||
          num1 >= 256 ||
          num2 < 0 ||
          num2 >= 256 ||
          num3 < 0 ||
          num3 >= 256
        ) {
          console.log("不符合范围:", position);
          return false;
        }
        return true;
      }); // 确保符合 "1-1-1" 格式

    if (newPositions.length) {
      // **去重**，确保不添加已有的值
      if (!plan.positions) {
        plan.positions = [];
      }
      const uniquePositions = newPositions.filter(
        (pos) => !plan.positions.includes(pos)
      );

      if (uniquePositions.length) {
        plan.positions.push(...uniquePositions);
        console.log("成功添加的新数据:", uniquePositions);
      } else {
        console.warn("所有粘贴的数据都已存在，无需添加");
      }
    }
  });
};
// 1-1-1， fas, 2562-1-1, 2-2-2
const deletePlan = (index: number) => {
  planList.value.splice(index, 1);
};

const isValidPlanSet = () => {
  if (upgradeSelection.value == 1) {
    // Svc001 三文件改造：需要终端 + 固件/MD5/签名三个文件都已选定
    return (
      endpointSelection.value &&
      svc001FileSelection.firmware !== undefined &&
      svc001FileSelection.md5 !== undefined &&
      svc001FileSelection.sign !== undefined
    );
  }
  // Svc004 新协议：每行设备都需要填写完整
  return !svc004PlanList.value.some(
    (plan) =>
      !plan.devType ||
      !plan.devName ||
      plan.subLv === null ||
      !isSubAddrReady(plan) ||
      plan.subType === null ||
      !plan.subName ||
      plan.fileUid === null
  );
};

/** 升级信息是否配置完成（Step 4 解锁条件） */
const isPlanReady = computed(
  () => !!upgradeSelection.value && isValidPlanSet()
);

/** 升级信息缺失项清单（实时展示在 Step 3 中，点击创建时逐条提示） */
const planIssues = computed<string[]>(() => {
  const issues: string[] = [];
  if (!upgradeSelection.value) {
    issues.push(t("CUPV.selectUpgradeModeError"));
    return issues;
  }
  if (upgradeSelection.value === 1) {
    if (!endpointSelection.value) {
      issues.push("终端未关联（请确认船舶已绑定终端）");
    }
    if (svc001FileSelection.firmware === undefined) {
      issues.push("未选择固件文件");
    }
    if (svc001FileSelection.md5 === undefined) {
      issues.push("未选择 MD5 校验文件");
    }
    if (svc001FileSelection.sign === undefined) {
      issues.push("未选择签名文件");
    }
  } else {
    svc004PlanList.value.forEach((plan, index) => {
      const missing: string[] = [];
      if (!plan.devType) missing.push("设备类型");
      if (!plan.devName) missing.push("设备名称");
      if (plan.subLv === null) missing.push("子设备层级");
      else if (!isSubAddrReady(plan)) {
        if (plan.subLv === 3) {
          missing.push("三级序号（至少一个编号）");
        } else if (parseLvNum(plan.lv3.val) === null) {
          missing.push("三级序号（1~255 整数）");
        } else if (plan.subLv === 2 && plan.lv2.list.length === 0) {
          missing.push("二级序号（至少一个编号）");
        } else if (plan.subLv === 1 && parseLvNum(plan.lv2.val) === null) {
          missing.push("二级序号（1~255 整数）");
        } else {
          missing.push("一级序号（至少一个编号）");
        }
      }
      if (plan.subType === null || !plan.subName) {
        missing.push(
          plan.subInfoError
            ? "子设备信息（格式错误，应为 名称-类型，如 EMU-6）"
            : "子设备信息"
        );
      }
      if (plan.fileUid === null) missing.push("升级文件");
      if (missing.length) {
        issues.push(`第 ${index + 1} 行：${missing.join("、")}未填写`);
      }
    });
  }
  return issues;
});

/**
 * 点击创建时逐项校验并提示具体错误（替代禁用按钮的"无反馈"体验）
 */
const validateForm = (): boolean => {
  if (!ship.value) {
    ElMessage.error("船舶信息尚未加载完成，请稍候");
    return false;
  }
  if (fileList.value.length === 0) {
    ElMessage.error("请先上传升级文件");
    return false;
  }
  if (upgradeSelection.value === undefined) {
    ElMessage.error(t("CUPV.selectUpgradeModeError"));
    return false;
  }
  if (planIssues.value.length > 0) {
    ElMessage.error("升级信息未填写完整：" + planIssues.value[0]);
    return false;
  }
  if (upgradeDate.value === undefined) {
    ElMessage.error("请设置过期时间");
    return false;
  }
  if (new Date(upgradeDate.value) < getTargetTime(config.minimumTimeInterval)) {
    ElMessage.error(t("CUPV.timeError"));
    return false;
  }
  return true;
};

// 校验非BMS类型的 subInfo 格式
const validateSubInfo = (): boolean => {
  for (const plan of svc004PlanList.value) {
    if (plan.devType !== "BMS" && plan.subInfo) {
      const parts = plan.subInfo.split("-");
      if (
        parts.length !== 2 ||
        !parts[0] ||
        !parts[1] ||
        isNaN(Number(parts[1]))
      ) {
        ElMessage.error(
          `子设备格式错误："${plan.subInfo}"，请使用"名称-类型"格式，如 EMU-6`
        );
        return false;
      }
    }
  }
  return true;
};
const fileIdRefTable = ref<
  {
    id: string;
    uid: number;
    name: string;
    path: string;
    fileMd5: string;
  }[]
>([]);

// ==================== Svc001 终端升级三文件选择（固件 / MD5 / 签名） ====================
const svc001FileSelection = reactive<{
  firmware: number | undefined;
  md5: number | undefined;
  sign: number | undefined;
}>({ firmware: undefined, md5: undefined, sign: undefined });

/**
 * 按扩展名判断文件角色：.md5 -> MD5 文件；.minisig/.sig/.sign/.asc -> 签名文件；其余 -> 固件
 */
const isMd5File = (name: string) => /\.md5$/i.test(name);
const isSignFile = (name: string) => /\.(minisig|sig|sign|asc)$/i.test(name);

/**
 * 按扩展名自动预填三个文件位（未填的才填，用户可手动调整）
 */
const autoFillSvc001FileSelection = () => {
  const list = fileList.value;
  if (!svc001FileSelection.md5) {
    const f = list.find((x) => isMd5File(x.name));
    svc001FileSelection.md5 = f?.uid;
  }
  if (!svc001FileSelection.sign) {
    const f = list.find((x) => isSignFile(x.name));
    svc001FileSelection.sign = f?.uid;
  }
  if (!svc001FileSelection.firmware) {
    const f = list.find((x) => !isMd5File(x.name) && !isSignFile(x.name));
    svc001FileSelection.firmware = f?.uid;
  }
};

// fileList 变化 / 切换到终端升级模式时自动预填
watch(fileList, autoFillSvc001FileSelection, { deep: true });
watch(upgradeSelection, (val) => {
  if (val === 1) autoFillSvc001FileSelection();
});

// ==================== 步骤卡自动滚动引导 ====================
const step3Card = ref<HTMLElement>();
const step4Card = ref<HTMLElement>();

const scrollToCard = (el: HTMLElement | undefined) => {
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
};

// 文件选择完成（Step 3 出现）时自动滚动引导，无需手动下滑
watch(
  () => fileList.value.length > 0,
  (hasFiles, prev) => {
    if (hasFiles && !prev) {
      nextTick(() => scrollToCard(step3Card.value));
    }
  }
);

// 升级信息配置完成（Step 4 解锁）且尚未设置时间时，滚动到时间步骤
watch(isPlanReady, (ready, prev) => {
  if (ready && !prev && !upgradeDate.value) {
    // 稍作延迟，避免与 Step 3 出现时的滚动互相抢占
    setTimeout(() => scrollToCard(step4Card.value), 400);
  }
});

// 升级过程展示
const isUpgradeStart = ref<boolean>(false);
const upgradePlanPercent = ref<number>(0);
const upgradePlanStatus = ref<string>("");
const upgradePlanTip = ref<string>("");
const createUpgradePlan = async () => {
  // 管理员对船舶的写入权限认证
  const writeAuthority = await validateShipAuthorizationApi(shipId.value, 16);
  if (!writeAuthority) {
    ElMessage.error(
      "管理员对" + ship.value?.name + "的写入权限已过期，请重新申请"
    );
    router.replace({ name: "overall" });
    return;
  }
  // 数据验证（逐项校验并提示具体错误）
  if (!validateForm()) return;
  isUpgradeStart.value = true;
  upgradePlanTip.value = t("CUPV.fileUploadRate", {
    current: fileIdRefTable.value.length,
    total: fileList.value.length,
  });

  let allUploaded = true;
  for (const file of fileList.value) {
    try {
      if (!file.uid || !file.raw) {
        throw new Error("Invalid file data");
      }

      // Svc001 三文件改造：不再前端计算/上传 MD5（后端跳过比对，仍返回磁盘 MD5 供设备升级使用）
      const formData = new FormData();
      formData.append("uid", String(file.uid));
      formData.append("file", file.raw);
      formData.append("shipId", shipId.value);

      // 异步上传逻辑
      const result = await httpAuthorized.post("/file/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // 更新 fileIdRefTable 中对应条目的 id/path/fileMd5（fileMd5 为后端磁盘 MD5，设备升级使用）
      const entry = _.find(fileIdRefTable.value, {
        uid: Number(result.data.data.result.uid),
      });
      if (entry) {
        entry.id = result.data.data.result.id;
        entry.name = result.data.data.result.name || entry.name;
        entry.path = result.data.data.result.path || "";
        entry.fileMd5 = result.data.data.result.fileMd5 || entry.fileMd5;
      }
      upgradePlanTip.value = t("CUPV.fileUploadRate", {
        current: fileIdRefTable.value.length,
        total: fileList.value.length,
      });
      upgradePlanPercent.value =
        (80 / fileList.value.length) * fileIdRefTable.value.length;
    } catch (error: any) {
      // 后端返回 FILE_MD5_MISMATCH 时提示 MD5 不一致
      const errMsg =
        error?.response?.data?.message || error?.data?.message || "";
      if (errMsg.includes("MD5") || errMsg.includes("md5")) {
        ElMessage.error(
          "文件MD5校验不一致，文件可能已损坏，请重新选择文件上传"
        );
      } else {
        ElMessage.error(t("CUPV.fileUploadFail"));
      }
      allUploaded = false; // 上传失败，终止后续上传
      break;
    }
  }

  // 任一文件上传失败（id 仍为空）则中止创建，避免携带空 fileId 的脏升级计划
  if (!allUploaded || fileIdRefTable.value.some((e) => !e.id)) {
    console.error("文件上传终止");
    upgradePlanStatus.value = "exception";
    updateUpgradeEndState(2);
    return;
  }

  // 终端升级（Svc001 新协议：三文件）
  if (upgradeSelection.value === 1) {
    if (endpointSelection.value === undefined) return;
    if (
      svc001FileSelection.firmware === undefined ||
      svc001FileSelection.md5 === undefined ||
      svc001FileSelection.sign === undefined
    ) {
      ElMessage.error("请完整选择固件、MD5、签名三个文件");
      return;
    }
    const firmwareEntry = _.find(fileIdRefTable.value, {
      uid: svc001FileSelection.firmware,
    }) as { id: string; uid: number; name: string; path: string } | undefined;
    const md5Entry = _.find(fileIdRefTable.value, {
      uid: svc001FileSelection.md5,
    }) as { id: string; uid: number; name: string; path: string } | undefined;
    const signEntry = _.find(fileIdRefTable.value, {
      uid: svc001FileSelection.sign,
    }) as { id: string; uid: number; name: string; path: string } | undefined;
    const result = await createEndpointUpgradePlanApi({
      planName: "终端升级-" + (ship.value?.name || ""),
      shipId: shipId.value,
      endpointId: endpointSelection.value!,
      planTime: upgradeDate.value,
      fileId: firmwareEntry?.id || "",
      fileName: firmwareEntry?.name || "",
      filePath: firmwareEntry?.path || "",
      md5FileId: md5Entry?.id || "",
      md5FileName: md5Entry?.name || "",
      md5FilePath: md5Entry?.path || "",
      signFileId: signEntry?.id || "",
      signFileName: signEntry?.name || "",
      signFilePath: signEntry?.path || "",
    });
    console.log(result);
    if (result) {
      upgradePlanPercent.value = 100;
      upgradePlanStatus.value = "success";
      updateUpgradeEndState(1);
    } else {
      upgradePlanStatus.value = "exception";
      ElMessage.error(t("CUPV.createUpgradePlanFail"));
      updateUpgradeEndState(2);
    }
  }
  // 设备升级（Svc004 新协议）
  else if (upgradeSelection.value === 2) {
    // 校验非BMS类型的 subInfo 格式
    if (!validateSubInfo()) return;

    // 构建升级项列表
    const items: {
      devName: string;
      subName: string;
      subLv: number;
      subType: number;
      subId: string[];
      fileId: string;
      fileName: string;
      filePath: string;
      fileMd5: string;
    }[] = svc004PlanList.value
      .filter(
        (plan) =>
          plan.devType &&
          plan.devName &&
          plan.subLv !== null &&
          isSubAddrReady(plan) &&
          plan.subType !== null &&
          plan.subName &&
          plan.fileUid !== null
      )
      .map((plan) => {
        const fileEntry = _.find(fileIdRefTable.value, {
          uid: plan.fileUid,
        }) as
          | {
              id: string;
              uid: number;
              name: string;
              path: string;
              fileMd5: string;
            }
          | undefined;
        return {
          devName: plan.devName,
          subLv: plan.subLv!,
          subName: plan.subName,
          subType: plan.subType!,
          subId: buildFullSubIds(plan),
          fileId: fileEntry?.id || "",
          fileName: fileEntry?.name || "",
          filePath: fileEntry?.path || "",
          fileMd5: fileEntry?.fileMd5 || "",
        };
      });

    if (items.length === 0) {
      ElMessage.error("请至少添加一个有效的设备升级项");
      return;
    }

    const result = await createSvc004UpgradeTaskApi({
      planName: "设备升级-" + (ship.value?.name || ""),
      endpointId: endpointSelection.value || "",
      shipId: shipId.value,
      planTime: upgradeDate.value!,
      items: items,
    });

    upgradePlanPercent.value = 100;
    if (result) {
      upgradePlanStatus.value = "success";
      updateUpgradeEndState(1);
    } else {
      upgradePlanStatus.value = "exception";
      ElMessage.error(t("CUPV.createUpgradePlanFail"));
      updateUpgradeEndState(2);
    }
  }
};

// 升级结束
const isUpgradeEnd = ref<boolean>(false);
// 默认结果为失败
const upgradePlanResult = reactive<{
  title: string;
  icon: string;
  subTitle: string;
}>({
  icon: "error",
  title: t("CUPV.upgradePlanResult.error.title"),
  subTitle: t("CUPV.upgradePlanResult.error.subTitle"),
});

const updateUpgradeEndState = (flag: number) => {
  setTimeout(() => {
    isUpgradeEnd.value = true;
    // 成功
    if (flag == 1) {
      upgradePlanResult.icon = "success";
      upgradePlanResult.title = t("CUPV.upgradePlanResult.success.title");
      upgradePlanResult.subTitle = t("CUPV.upgradePlanResult.success.subTitle");
    }
  }, 500);
};

onMounted(async () => {
  // 确保翻译表就绪：登录后首次进入时 App 挂载阶段的加载因未登录(401)失败，
  // 设备升级的设备名下拉翻译依赖此缓存；与 App 启动加载共享同一次请求
  await loadTranslations();
  getShipInfo();
  getEndpointList();
  getDeviceList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_result = _resolveComponent("el-result")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"hero-bg\" data-v-9538ee86><svg viewBox=\"0 0 800 200\" preserveAspectRatio=\"none\" class=\"hero-svg\" data-v-9538ee86><circle cx=\"100\" cy=\"100\" r=\"180\" fill=\"rgba(255,255,255,0.05)\" data-v-9538ee86></circle><circle cx=\"650\" cy=\"40\" r=\"150\" fill=\"rgba(8,145,178,0.22)\" data-v-9538ee86></circle><path d=\"M 0 150 Q 200 100 400 130 T 800 110\" stroke=\"rgba(255,255,255,0.10)\" stroke-width=\"1\" fill=\"none\" data-v-9538ee86></path><path d=\"M 0 170 Q 220 140 420 160 T 800 140\" stroke=\"rgba(255,255,255,0.05)\" stroke-width=\"1\" fill=\"none\" data-v-9538ee86></path></svg></div>", 1)),
      _createElementVNode("button", {
        class: "back-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowLeft))
          ]),
          _: 1
        }),
        _cache[11] || (_cache[11] = _createElementVNode("span", null, "返回", -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Promotion))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "hero-tag" }, "CREATE UPGRADE PLAN · 创建升级计划", -1)),
          _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t("r.create_upgrade_plan")), 1),
          (ship.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "目标船舶：" + _toDisplayString(ship.value.name), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (shipId.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (ship.value)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CircleCheck))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, "1"))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t("CUPV.shipInfo")), 1),
              (ship.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, " - " + _toDisplayString(ship.value.name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["step-status", { done: ship.value }])
            }, _toDisplayString(ship.value ? "已加载" : "加载中"), 3)
          ]),
          (ship.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Ship))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "info-label" }, "船舶名称", -1)),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(ship.value.name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Document))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "info-label" }, "船舶 ID", -1)),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(ship.value.id), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (ship.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", {
              class: _normalizeClass(["step-badge", { done: fileList.value.length > 0 }])
            }, [
              (fileList.value.length > 0)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CircleCheck))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_26, "2"))
            ], 2),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t("CUPV.selectFile")), 1),
              (fileList.value.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, " - " + _toDisplayString(fileList.value.length) + _toDisplayString(_ctx.$t("CUPV.fileCount")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["step-status", { done: fileList.value.length > 0 }])
            }, _toDisplayString(fileList.value.length > 0 ? "已选择" : "待选择"), 3)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_el_upload, {
              "file-list": fileList.value,
              "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((fileList).value = $event)),
              class: "upload-demo",
              drag: "",
              multiple: "",
              "on-change": handleFileChange,
              "on-remove": handleFileRemove,
              "auto-upload": false
            }, {
              tip: _withCtx(() => [
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("CUPV.file.sizeTip")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_upload_filled)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_30, [
                  _createTextVNode(_toDisplayString(_ctx.$t("CUPV.file.beforeText")) + " ", 1),
                  _createElementVNode("em", null, _toDisplayString(_ctx.$t("CUPV.file.text")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("CUPV.file.afterText")), 1)
                ])
              ]),
              _: 1
            }, 8, ["file-list"])
          ])
        ]))
      : _createCommentVNode("", true),
    (fileList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          ref_key: "step3Card",
          ref: step3Card,
          class: "step-card"
        }, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", {
              class: _normalizeClass(["step-badge", { done: upgradeSelection.value && isValidPlanSet() }])
            }, [
              (upgradeSelection.value && isValidPlanSet())
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CircleCheck))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_33, "3"))
            ], 2),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t("CUPV.upgradeInfo")), 1)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["step-status", { done: upgradeSelection.value && isValidPlanSet() }])
            }, _toDisplayString(upgradeSelection.value && isValidPlanSet() ? "已配置" : "待配置"), 3)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_el_radio_group, {
              modelValue: upgradeSelection.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((upgradeSelection).value = $event)),
              class: "upgrade-radio-group"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  value: 1,
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("CUPV.endpointUpgrade")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  value: 2,
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("CUPV.deviceUpgrade")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (planIssues.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(WarningFilled))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_37, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "plan-issues-title" }, " 升级信息还未填写完整，请补全以下内容： ", -1)),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planIssues.value, (issue, i) => {
                        return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(issue), 1))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (upgradeSelection.value == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-title" }, "#", -1)),
                    _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("CUPV.planHeader.devType")), 1),
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("CUPV.planHeader.devName")), 1),
                    _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("CUPV.planHeader.subInfo")), 1),
                    _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("CUPV.planHeader.subLv")), 1),
                    _createElementVNode("div", _hoisted_44, [
                      _createTextVNode(_toDisplayString(_ctx.$t("CUPV.planHeader.lv3")) + " ", 1),
                      _createVNode(_component_el_tooltip, {
                        placement: "top",
                        effect: "light",
                        "show-after": 150,
                        "popper-class": "subid-help-popper"
                      }, {
                        content: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("div", { class: "tt-title" }, "三级/二级/一级序号填写说明", -1),
                          _createElementVNode("div", { class: "tt-row" }, [
                            _createElementVNode("span", { class: "tt-lv" }, "层级 3"),
                            _createTextVNode(" 三级序号输入多个编号，如 1、5 → 1-*-*、5-*-* ")
                          ], -1),
                          _createElementVNode("div", { class: "tt-row" }, [
                            _createElementVNode("span", { class: "tt-lv" }, "层级 2"),
                            _createTextVNode(" 固定一个三级编号，二级序号输入多个 如 3 + 1、4 → 3-1-*、3-4-* ")
                          ], -1),
                          _createElementVNode("div", { class: "tt-row" }, [
                            _createElementVNode("span", { class: "tt-lv" }, "层级 1"),
                            _createTextVNode(" 固定三级、二级编号，一级序号输入多个 如 1-2 + 7、15 → 1-2-7、1-2-15 ")
                          ], -1),
                          _createElementVNode("div", { class: "tt-sep" }, null, -1),
                          _createElementVNode("div", { class: "tt-row" }, " · 编号范围 1~255，多值框输入后回车添加 ", -1),
                          _createElementVNode("div", { class: "tt-row" }, "· 支持粘贴编号列表批量添加", -1),
                          _createElementVNode("div", { class: "tt-row" }, " · 粘贴完整地址时自动按层级与上级编号筛选提取 ", -1)
                        ]))]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { class: "col-help-icon" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(QuestionFilled))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createTextVNode(_toDisplayString(_ctx.$t("CUPV.planHeader.lv2")) + " ", 1),
                      _createVNode(_component_el_tooltip, {
                        placement: "top",
                        effect: "light",
                        "show-after": 150,
                        "popper-class": "subid-help-popper"
                      }, {
                        content: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                          _createElementVNode("div", { class: "tt-title" }, "二级序号填写说明", -1),
                          _createElementVNode("div", { class: "tt-row" }, [
                            _createElementVNode("span", { class: "tt-lv" }, "层级 2"),
                            _createTextVNode(" 输入多个二级编号（三级序号已固定），如 1、4 ")
                          ], -1),
                          _createElementVNode("div", { class: "tt-row" }, [
                            _createElementVNode("span", { class: "tt-lv" }, "层级 1"),
                            _createTextVNode(" 仅固定一个二级编号，一级序号另输入多个 ")
                          ], -1),
                          _createElementVNode("div", { class: "tt-row" }, [
                            _createElementVNode("span", { class: "tt-lv" }, "层级 3"),
                            _createTextVNode(" 本列不使用（禁用） ")
                          ], -1),
                          _createElementVNode("div", { class: "tt-sep" }, null, -1),
                          _createElementVNode("div", { class: "tt-row" }, " · 编号范围 1~255，多值框输入后回车添加 ", -1),
                          _createElementVNode("div", { class: "tt-row" }, " · 支持粘贴编号列表或完整地址（自动筛选提取） ", -1)
                        ]))]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { class: "col-help-icon" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(QuestionFilled))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createTextVNode(_toDisplayString(_ctx.$t("CUPV.planHeader.lv1")) + " ", 1),
                      _createVNode(_component_el_tooltip, {
                        placement: "top",
                        effect: "light",
                        "show-after": 150,
                        "popper-class": "subid-help-popper"
                      }, {
                        content: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createElementVNode("div", { class: "tt-title" }, "一级序号填写说明", -1),
                          _createElementVNode("div", { class: "tt-row" }, [
                            _createElementVNode("span", { class: "tt-lv" }, "层级 1"),
                            _createTextVNode(" 输入多个一级编号（三级、二级已固定），如 7、15 ")
                          ], -1),
                          _createElementVNode("div", { class: "tt-row" }, [
                            _createElementVNode("span", { class: "tt-lv" }, "层级 2/3"),
                            _createTextVNode(" 本列不使用（禁用） ")
                          ], -1),
                          _createElementVNode("div", { class: "tt-sep" }, null, -1),
                          _createElementVNode("div", { class: "tt-row" }, "· 编号范围 1~255，输入后回车添加", -1),
                          _createElementVNode("div", { class: "tt-row" }, " · 支持粘贴编号列表或完整地址（自动筛选提取） ", -1)
                        ]))]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { class: "col-help-icon" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(QuestionFilled))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t("CUPV.planHeader.fileId")), 1),
                    _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("CUPV.planHeader.delete")), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(svc004PlanList.value, (plan, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "plan-row"
                    }, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("span", _hoisted_50, _toDisplayString(index + 1), 1)
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_el_select, {
                          modelValue: plan.devType,
                          "onUpdate:modelValue": ($event: any) => ((plan.devType) = $event),
                          style: {"width":"100%"},
                          onChange: ($event: any) => (onDevTypeChange(plan))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceTypeList.value, (dt) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: dt,
                                label: dt,
                                value: dt
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_el_select, {
                          modelValue: plan.devName,
                          "onUpdate:modelValue": ($event: any) => ((plan.devName) = $event),
                          style: {"width":"100%"},
                          disabled: !plan.devType
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDeviceNamesByType(plan.devType), (device) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: device.name,
                                label: _unref(translateName)(device.name),
                                value: device.name
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        (plan.devType === 'BMS')
                          ? (_openBlock(), _createBlock(_component_el_select, {
                              key: 0,
                              modelValue: plan.subInfo,
                              "onUpdate:modelValue": ($event: any) => ((plan.subInfo) = $event),
                              style: {"width":"100%"},
                              disabled: !plan.devType,
                              onChange: ($event: any) => (onSubInfoChange(plan))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SUB_TYPE_MAP), (name, type) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: type,
                                    label: name + '-' + type,
                                    value: name + '-' + type
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]))
                          : (_openBlock(), _createBlock(_component_el_input, {
                              key: 1,
                              modelValue: plan.subInfo,
                              "onUpdate:modelValue": ($event: any) => ((plan.subInfo) = $event),
                              placeholder: "子设备名称-子设备类型",
                              disabled: !plan.devType,
                              class: _normalizeClass({ 'sub-info-error': plan.subInfoError }),
                              onBlur: ($event: any) => (onSubInfoBlur(plan)),
                              onInput: ($event: any) => (onSubInfoInput(plan))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class", "onBlur", "onInput"]))
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_el_select, {
                          modelValue: plan.subLv,
                          "onUpdate:modelValue": ($event: any) => ((plan.subLv) = $event),
                          disabled: !plan.devType,
                          style: {"width":"100%"},
                          placeholder: "选择层级",
                          onChange: ($event: any) => (onSubLvChange(plan))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "3（三级设备）",
                              value: 3
                            }),
                            _createVNode(_component_el_option, {
                              label: "2（二级设备）",
                              value: 2
                            }),
                            _createVNode(_component_el_option, {
                              label: "1（一级设备）",
                              value: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        (plan.subLv === 3)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.lv3.list, (id, idx) => {
                                  return (_openBlock(), _createBlock(_component_el_tag, {
                                    key: idx,
                                    closable: "",
                                    size: "small",
                                    type: "info",
                                    effect: "light",
                                    onClose: ($event: any) => (plan.lv3.list.splice(idx, 1))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(id), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClose"]))
                                }), 128))
                              ]),
                              _createVNode(_component_el_input, {
                                modelValue: plan.lv3.input,
                                "onUpdate:modelValue": ($event: any) => ((plan.lv3.input) = $event),
                                size: "small",
                                placeholder: "输入三级编号，回车添加",
                                disabled: !plan.devType || plan.subLv === null,
                                class: _normalizeClass({ 'sub-id-error': plan.lv3.error }),
                                onInput: ($event: any) => (onLvInput(plan.lv3)),
                                onPaste: ($event: any) => (handleLvPaste(plan, 0, plan.lv3, $event)),
                                onKeyup: _withKeys(($event: any) => (handleLvEnter(plan.lv3)), ["enter"])
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class", "onInput", "onPaste", "onKeyup"])
                            ]))
                          : (_openBlock(), _createBlock(_component_el_input, {
                              key: 1,
                              modelValue: plan.lv3.val,
                              "onUpdate:modelValue": ($event: any) => ((plan.lv3.val) = $event),
                              size: "small",
                              placeholder: "三级编号（固定）",
                              disabled: !plan.devType || plan.subLv === null,
                              class: _normalizeClass({ 'sub-info-error': plan.lv3.error }),
                              onInput: ($event: any) => (onLvValInput(plan.lv3)),
                              onBlur: ($event: any) => (onLvValBlur(plan.lv3))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class", "onInput", "onBlur"])),
                        (plan.subLv === 3 && buildFullSubIds(plan).length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, " 将升级：" + _toDisplayString(previewAddrs(plan)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        (plan.subLv === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.lv2.list, (id, idx) => {
                                  return (_openBlock(), _createBlock(_component_el_tag, {
                                    key: idx,
                                    closable: "",
                                    size: "small",
                                    type: "info",
                                    effect: "light",
                                    onClose: ($event: any) => (plan.lv2.list.splice(idx, 1))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(id), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClose"]))
                                }), 128))
                              ]),
                              _createVNode(_component_el_input, {
                                modelValue: plan.lv2.input,
                                "onUpdate:modelValue": ($event: any) => ((plan.lv2.input) = $event),
                                size: "small",
                                placeholder: "输入二级编号，回车添加",
                                disabled: !plan.devType || plan.subLv !== 2,
                                class: _normalizeClass({ 'sub-id-error': plan.lv2.error }),
                                onInput: ($event: any) => (onLvInput(plan.lv2)),
                                onPaste: ($event: any) => (handleLvPaste(plan, 1, plan.lv2, $event)),
                                onKeyup: _withKeys(($event: any) => (handleLvEnter(plan.lv2)), ["enter"])
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class", "onInput", "onPaste", "onKeyup"]),
                              (plan.subLv === 2 && buildFullSubIds(plan).length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, " 将升级：" + _toDisplayString(previewAddrs(plan)), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createBlock(_component_el_input, {
                              key: 1,
                              modelValue: plan.lv2.val,
                              "onUpdate:modelValue": ($event: any) => ((plan.lv2.val) = $event),
                              size: "small",
                              placeholder: "二级编号（固定）",
                              disabled: !plan.devType || plan.subLv !== 1,
                              class: _normalizeClass({ 'sub-info-error': plan.lv2.error }),
                              onInput: ($event: any) => (onLvValInput(plan.lv2)),
                              onBlur: ($event: any) => (onLvValBlur(plan.lv2))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class", "onInput", "onBlur"]))
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.lv1.list, (id, idx) => {
                              return (_openBlock(), _createBlock(_component_el_tag, {
                                key: idx,
                                closable: "",
                                size: "small",
                                type: "info",
                                effect: "light",
                                onClose: ($event: any) => (plan.lv1.list.splice(idx, 1))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(id), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClose"]))
                            }), 128))
                          ]),
                          _createVNode(_component_el_input, {
                            modelValue: plan.lv1.input,
                            "onUpdate:modelValue": ($event: any) => ((plan.lv1.input) = $event),
                            size: "small",
                            placeholder: "输入一级编号，回车添加",
                            disabled: !plan.devType || plan.subLv !== 1,
                            class: _normalizeClass({ 'sub-id-error': plan.lv1.error }),
                            onInput: ($event: any) => (onLvInput(plan.lv1)),
                            onPaste: ($event: any) => (handleLvPaste(plan, 2, plan.lv1, $event)),
                            onKeyup: _withKeys(($event: any) => (handleLvEnter(plan.lv1)), ["enter"])
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class", "onInput", "onPaste", "onKeyup"]),
                          (plan.subLv === 1 && buildFullSubIds(plan).length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, " 将升级：" + _toDisplayString(previewAddrs(plan)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createVNode(_component_el_select, {
                          modelValue: plan.fileUid,
                          "onUpdate:modelValue": ($event: any) => ((plan.fileUid) = $event),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (file) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: file.uid,
                                label: file.name,
                                value: file.uid
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        (index > 0)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "danger",
                              link: "",
                              icon: _unref(Delete),
                              onClick: ($event: any) => (deleteSvc004Plan(index))
                            }, null, 8, ["icon", "onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128)),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    class: "add-plan-btn",
                    icon: _unref(Plus),
                    onClick: addSvc004Plan
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("CUPV.addPlan")), 1)
                    ]),
                    _: 1
                  }, 8, ["icon"])
                ]))
              : (upgradeSelection.value == 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_69, [
                      _createVNode(_component_el_icon, { class: "info-icon-tip" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(InfoFilled))
                        ]),
                        _: 1
                      }),
                      _cache[21] || (_cache[21] = _createElementVNode("span", null, "终端升级：终端 ID 将自动关联当前船舶，无需手动选择", -1))
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "firmware-label" }, "终端当前固件：", -1)),
                      (endpointFirmware.value && endpointFirmware.value.queryStatus === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_71, "终端无响应"))
                        : (endpointFirmware.value && endpointFirmware.value.queryStatus === 4)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_72, "终端离线"))
                          : (endpointFirmware.value && endpointFirmware.value.queryStatus === 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(endpointFirmware.value.message || "终端异常"), 1))
                            : (endpointFirmware.value && endpointFirmware.value.firmware)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _createElementVNode("span", _hoisted_74, _toDisplayString(endpointFirmware.value.firmware), 1),
                                  (endpointFirmware.value.firmwareReportTime)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_75, "（" + _toDisplayString(endpointFirmware.value.firmwareReportTime) + "）", 1))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_76, "未知")),
                      _createVNode(_component_el_button, {
                        class: "firmware-refresh-btn",
                        link: "",
                        size: "small",
                        disabled: firmwareLoading.value || !endpointSelection.value,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (loadEndpointFirmware(true)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(firmwareLoading.value ? "查询中..." : "刷新"), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "file-label" }, "固件文件：", -1)),
                        _createVNode(_component_el_select, {
                          modelValue: svc001FileSelection.firmware,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((svc001FileSelection.firmware) = $event)),
                          placeholder: "选择固件文件",
                          clearable: "",
                          class: "file-select"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (f) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: f.uid,
                                label: f.name,
                                value: f.uid!
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "file-label" }, "MD5 文件：", -1)),
                        _createVNode(_component_el_select, {
                          modelValue: svc001FileSelection.md5,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((svc001FileSelection.md5) = $event)),
                          placeholder: "选择 MD5 校验文件",
                          clearable: "",
                          class: "file-select"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (f) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: f.uid,
                                label: f.name,
                                value: f.uid!
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "file-label" }, "签名文件：", -1)),
                        _createVNode(_component_el_select, {
                          modelValue: svc001FileSelection.sign,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((svc001FileSelection.sign) = $event)),
                          placeholder: "选择签名文件",
                          clearable: "",
                          class: "file-select"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (f) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: f.uid,
                                label: f.name,
                                value: f.uid!
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
          ])
        ], 512))
      : _createCommentVNode("", true),
    (fileList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          ref_key: "step4Card",
          ref: step4Card,
          class: "step-card time-step-card"
        }, [
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", {
              class: _normalizeClass(["step-badge", { done: upgradeDate.value }])
            }, [
              (upgradeDate.value)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CircleCheck))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_82, "4"))
            ], 2),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t("CUPV.selectTime")), 1),
              (upgradeDate.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_84, " - " + _toDisplayString(_ctx.$d(new Date(upgradeDate.value), "long")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["step-status", { done: upgradeDate.value }])
            }, _toDisplayString(!isPlanReady.value ? "待升级信息完成" : upgradeDate.value ? "已选择" : "待选择"), 3)
          ]),
          _createElementVNode("div", _hoisted_85, [
            (!isPlanReady.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Lock))
                    ]),
                    _: 1
                  }),
                  _cache[26] || (_cache[26] = _createElementVNode("span", null, "请先完成上方「升级信息」步骤，配置完成后即可设置过期时间", -1))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_date_picker, {
              modelValue: upgradeDate.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((upgradeDate).value = $event)),
              type: "datetime",
              placeholder: "Pick a Date",
              format: "YYYY/MM/DD HH:mm:ss",
              disabled: !isPlanReady.value,
              "disabled-date": optionsDisable,
              shortcuts: shorcuts,
              "show-now": false,
              "default-value": getTargetTime(20)
            }, null, 8, ["modelValue", "disabled", "default-value"])
          ])
        ], 512))
      : _createCommentVNode("", true),
    (shipId.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
          _createElementVNode("div", _hoisted_88, [
            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "bar-label" }, "创建进度", -1)),
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", {
                class: _normalizeClass(["step-dot", {
              done: !!ship.value,
              current: !ship.value && !!shipId.value,
            }]),
                title: "船舶信息"
              }, [
                (ship.value)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CircleCheck))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_90, "1"))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["step-line", { done: !!ship.value && fileList.value.length > 0 }])
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["step-dot", {
              done: fileList.value.length > 0,
              current: !!ship.value && fileList.value.length === 0,
            }]),
                title: "选择文件"
              }, [
                (fileList.value.length > 0)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CircleCheck))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_91, "2"))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["step-line", { done: !!upgradeSelection.value && isValidPlanSet() }])
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["step-dot", {
              done: !!upgradeSelection.value && isValidPlanSet(),
              current:
                fileList.value.length > 0 && (!upgradeSelection.value || !isValidPlanSet()),
            }]),
                title: "升级计划"
              }, [
                (upgradeSelection.value && isValidPlanSet())
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CircleCheck))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_92, "3"))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["step-line", { done: !!upgradeDate.value }])
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["step-dot", {
              done: !!upgradeDate.value,
              current: !!upgradeSelection.value && isValidPlanSet() && !upgradeDate.value,
            }]),
                title: "选择时间"
              }, [
                (upgradeDate.value)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CircleCheck))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_93, "4"))
              ], 2)
            ])
          ]),
          _createElementVNode("button", {
            class: _normalizeClass(["create-btn", { pending: !canCreate.value }]),
            onClick: createUpgradePlan
          }, [
            _cache[28] || (_cache[28] = _createElementVNode("span", { class: "ripple" }, null, -1)),
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Promotion))
              ]),
              _: 1
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("CUPV.createUpgradePlan")), 1)
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: isUpgradeStart.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isUpgradeStart).value = $event)),
      title: _ctx.$t('CUPV.addPlan'),
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_progress, {
          "text-inside": true,
          "stroke-width": 26,
          status: upgradePlanStatus.value,
          percentage: upgradePlanPercent.value
        }, null, 8, ["status", "percentage"]),
        _createElementVNode("p", null, _toDisplayString(upgradePlanTip.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: isUpgradeEnd.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((isUpgradeEnd).value = $event)),
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_result, {
          icon: upgradePlanResult.icon,
          title: upgradePlanResult.title,
          "sub-title": upgradePlanResult.subTitle
        }, {
          extra: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(router).back()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("CUPV.back")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["icon", "title", "sub-title"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})